import React, { useState, useEffect } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import LoadingOverlay from '~/components/LoadingOverlay';
import { 
    Table, 
    TableBody, 
    TableCell, 
    TableContainer, 
    TableHead, 
    TableRow, 
    TablePagination,
    Paper, 
    Typography 
} from '@material-ui/core';
import Actions_Wind_V2 from '~/Actions_Wind_V2';
import { logError } from '~/common/utils';

const styles = (theme) => ({
    root: {
        margin: theme.spacing(3),
        height: 'calc(100vh - 100px)',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
    },
    tableWrapper: {
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0,
    },
    tableContainer: {
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
    },
    tableContent: {
        flexGrow: 1,
        overflow: 'auto',
    },
    table: {
        minWidth: 650,
    },
    headerRow: {
        backgroundColor: '#e6f2ff',
    },
    oddRow: {
        backgroundColor: '#ffffff',
    },
    evenRow: {
        backgroundColor: '#f7f7f7',
    },
    link: {
        color: theme.palette.primary.main,
        textDecoration: 'none',
    },
    documentLabel: {
        padding: '4px 8px',
        borderRadius: '4px',
        display: 'inline-block',
    },
    dailyProgress: {
        backgroundColor: 'rgba(255, 255, 200, 0.5)',  // 淡黃色底, 透明 0.5
    },
    projectProgress: {
        backgroundColor: 'rgba(200, 255, 200, 0.5)',  // 淡綠色底, 透明 0.5
    },
    fanProgress: {
        backgroundColor: 'rgba(255, 200, 200, 0.5)',  // 淡粉紅色, 透明 0.5
    },
});

const Page_Notification_Work_Progress = ({ classes }) => {
    const [workProgress, setWorkProgress] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    useEffect(() => {
        setLoading(true);
        Actions_Wind_V2.getAllUnapprovalWorkProgress()
            .then((result) => {
                setWorkProgress(result);
            })
            .catch((error) => {
                logError(error, 'getAllUnapprovalWorkProgress');
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    // Calculate the current page's data
    const currentPageData = workProgress.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
    );

    return (
        <div className={classes.root}>
            <Typography variant="h5" gutterBottom>
                工程進度 - 文件處理提醒
            </Typography>
            {loading ? (
                <LoadingOverlay loading={loading} />
            ) : (
                <div className={classes.tableWrapper}>
                    <TableContainer component={Paper} className={classes.tableContainer}>
                        <div className={classes.tableContent}>
                            <Table className={classes.table}>
                                <TableHead>
                                    <TableRow className={classes.headerRow}>
                                        <TableCell>編號</TableCell>
                                        <TableCell>風場</TableCell>
                                        <TableCell>程序文件</TableCell>
                                        <TableCell>預定申請時間</TableCell>
                                        <TableCell>申請狀態</TableCell>
                                        <TableCell>簽核狀態</TableCell>
                                        <TableCell>相關連結</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {currentPageData.map((item, index) => (
                                        <TableRow
                                            key={item.id}
                                            className={index % 2 === 0 ? classes.evenRow : classes.oddRow}
                                        >
                                            <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                                            <TableCell>{item.windcontract_info.windfield_name}</TableCell>
                                            <TableCell>
                                                <span className={`${classes.documentLabel} ${
                                                    item.document_type_name === '工程進度-每日進度' ? classes.dailyProgress :
                                                    item.document_type_name === '工程進度-工程進度' ? classes.projectProgress :
                                                    item.document_type_name === '工程進度-風機點位工進' ? classes.fanProgress : ''
                                                }`}>
                                                    {item.document_type_name}
                                                </span>
                                            </TableCell>
                                            <TableCell>{item?.now_date || ''}</TableCell>
                                            <TableCell>{item.apply_status_description}</TableCell>
                                            <TableCell>{item.approval_status_description}</TableCell>
                                            <TableCell>
                                                <a
                                                    href={`${item.document_url}?contractId=${item.windcontract_info.windcontract_id}&id=${item.id}&date=${item?.now_date || ''}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className={classes.link}
                                                >
                                                    查看文件
                                                </a>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </div>
                        <TablePagination
                            rowsPerPageOptions={[5, 10]}
                            component="div"
                            count={workProgress.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onChangePage={handleChangePage}
                            onChangeRowsPerPage={handleChangeRowsPerPage}
                            labelRowsPerPage="每頁筆數"
                            labelDisplayedRows={({ from, to, count }) => 
                                `${from}-${to} 筆，共 ${count} 筆`
                            }
                        />
                    </TableContainer>
                </div>
            )}
            <br />
            <br />
            <br />
        </div>
    );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({});

export default compose(connect(mapStateToProps, mapDispatchToProps), withStyles(styles))(Page_Notification_Work_Progress);
